import axios from "axios";

import { UserEndPoints, GetBaseURL } from "./_serviceSettings";
import { OAuth2ServiceEndPoints, OAuth2Service } from "./index";
import Emitter from "_actions/emitter";

function GetDiffTimes(times) {
  if (!times || times === "null" || times === "undefined") {
    return -1; // Token yoksa veya geçersizse negatif döndür
  }
  try {
    let CurrentTime = new Date();
    let endTime = new Date(parseFloat(times));
    if (isNaN(endTime.getTime())) {
      return -1; // Geçersiz tarih
    }
    let difference = endTime.getTime() - CurrentTime.getTime(); // This will give difference in milliseconds
    let resultInMinutes = Math.round(difference / 60000);
    return resultInMinutes;
  } catch (error) {
    return -1; // Hata durumunda negatif döndür
  }
}

// Token yenileme işleminin aynı anda birden fazla kez çalışmasını önlemek için flag
let isRefreshingToken = false;
let refreshTokenPromise = null;

export async function checkTokenExpires(isTest = false) {
  try {
    // Token kontrolleri
    let refresh_token = localStorage.getItem("refresh_token");
    let expires_in = localStorage.getItem("expires_in");

    // Token yoksa veya geçersizse - bu normal bir durum olabilir (kullanıcı giriş yapmamış)
    if (!refresh_token || refresh_token === "null" || refresh_token === "undefined") {
      // Reject etme, sadece false döndür
      return Promise.resolve(false);
    }

    if (!expires_in || expires_in === "null" || expires_in === "undefined") {
      // Reject etme, sadece false döndür
      return Promise.resolve(false);
    }

    let diff = GetDiffTimes(expires_in);

    // GetDiffTimes hata döndürdüyse (negatif değer)
    if (diff < 0) {
      // Token süresi bilgisi geçersiz veya token süresi çoktan dolmuş
      // Bu durumda yenileme yapılamaz, false döndür
      return Promise.resolve(false);
    }

    // Token süresi 15 dakikadan fazla ise yenileme gerekmez
    if (diff >= 15) {
      return Promise.resolve(true);
    }

    // Token süresi bitmeden önce (0 ile 15 dakika arası) yenileme yapılmalı
    // diff > 0 && diff < 15 kontrolü - token süresi bitmeden önce yenile
    if (diff > 0 && diff < 15) {
      // Eğer zaten bir token yenileme işlemi devam ediyorsa, o promise'i bekle
      if (isRefreshingToken && refreshTokenPromise) {
        return refreshTokenPromise;
      }

      // Yeni token yenileme işlemi başlat
      isRefreshingToken = true;
      refreshTokenPromise = OAuth2Service.REFRESH_TOKEN(refresh_token)
        .then((data) => {
          isRefreshingToken = false;
          refreshTokenPromise = null;
          return Promise.resolve(data);
        })
        .catch((err) => {
          isRefreshingToken = false;
          refreshTokenPromise = null;
          // Token yenileme başarısız oldu - bu durumda reject et
          return Promise.reject(err);
        });

      return refreshTokenPromise;
    }

    // diff === 0 durumu (token tam şimdi bitiyor) - yine de yenilemeyi dene
    if (diff === 0) {
      if (isRefreshingToken && refreshTokenPromise) {
        return refreshTokenPromise;
      }

      isRefreshingToken = true;
      refreshTokenPromise = OAuth2Service.REFRESH_TOKEN(refresh_token)
        .then((data) => {
          isRefreshingToken = false;
          refreshTokenPromise = null;
          return Promise.resolve(data);
        })
        .catch((err) => {
          isRefreshingToken = false;
          refreshTokenPromise = null;
          // Token yenileme başarısız oldu - bu durumda reject et
          return Promise.reject(err);
        });

      return refreshTokenPromise;
    }

    return Promise.resolve(true);
  } catch (error) {
    isRefreshingToken = false;
    refreshTokenPromise = null;
    // Beklenmeyen hatalar için reject et
    return Promise.reject(error);
  }
}

export async function OAuth2_MakeRequestAndGetResponse(
  OperationUrl,
  _HTTPOperationType,
  JsonParams = null,
  isBlob
) {
  let request;
  let ress;
  try {
    /*
    let res=await getSession();
    var token = (res!=="" && res!==null && res!=="null" && res!==undefined)?
    JSON.parse(getSession).token:"";
   */

    let TokenRefresh = false;

    await checkTokenExpires(false)
      .then((data) => {
        TokenRefresh = true;
      })
      .catch((err) => {
        TokenRefresh = false;
      });

    let access_token = localStorage.getItem("access_token");

    request = client(access_token, isBlob);

    var js = JSON.stringify(JsonParams);
    //console.log(js);
    switch (_HTTPOperationType) {
      case HTTPOperationType.get:
        ress = await request.get(OperationUrl);
        break;
      case HTTPOperationType.post:
        ress = await request.post(OperationUrl, js);
        break;
      case HTTPOperationType.put:
        ress = await request.put(OperationUrl, js);
        break;
      case HTTPOperationType.delete:
        ress = await request.delete(OperationUrl);
        break;
      default:
        break;
    }

  

    return ress.data;
  } catch (error) {
    debugger;
    console.log(error);

    // request = client(token);
    //eger token dusmus ise

    await request
      .post(GetBaseURL() + UserEndPoints.GET_USERDETAIL, {})
      .then((xx) => {})
      .catch(async (xx) => {
        let access_token = localStorage.getItem("access_token");
        if (!access_token) {
          localStorage.clear();
          Emitter.emit("LOGOUT");
        }
        debugger;
        if (xx.response.status === 401) {
          let refresh_token = localStorage.getItem("refresh_token");
          await OAuth2Service.REFRESH_TOKEN(refresh_token)
            .then((xx) => {
              window.location.reload(true);
            })
            .catch((xx) => {
              debugger;
              localStorage.clear();
              Emitter.emit("LOGOUT");
            });
        }
      });

    return Promise.reject(error);
  }
}
export async function OAuth2_MakeRequestAndGetResponseLogin(
  OperationUrl,
  _HTTPOperationType,
  JsonParams = null,
  isBlob
) {
  let request;
  let ress;
  try {
    /*
    let res=await getSession();
    var token = (res!=="" && res!==null && res!=="null" && res!==undefined)?
    JSON.parse(getSession).token:"";
   */

    request = client(null, false);

    var js = JSON.stringify(JsonParams);
    //console.log(js);
    switch (_HTTPOperationType) {
      case HTTPOperationType.get:
        ress = await request.get(OperationUrl);
        break;
      case HTTPOperationType.post:
        ress = await request.post(OperationUrl, js);
        break;
      case HTTPOperationType.put:
        ress = await request.put(OperationUrl, js);
        break;
      case HTTPOperationType.delete:
        ress = await request.delete(OperationUrl);
        break;
      default:
        break;
    }
    debugger
    return ress.data;
  } catch (error) {
    debugger;
   
    return  Promise.reject(error);
  }
}
export async function MakeReqestBlob(
  OperationUrl,
  _HTTPOperationType,
  JsonParams = null,
  isBlob
) {
  let request;
  let ress;
  try {
    /*
    let res=await getSession();
    var token = (res!=="" && res!==null && res!=="null" && res!==undefined)?
    JSON.parse(getSession).token:"";
   */

    let TokenRefresh = false;

    await checkTokenExpires(false)
      .then((data) => {
        TokenRefresh = true;
      })
      .catch((err) => {
        TokenRefresh = false;
      });

    let access_token = localStorage.getItem("access_token");

    request = client(access_token, isBlob);
    var js = JSON.stringify(JsonParams);
    try {
      switch (_HTTPOperationType) {
        case HTTPOperationType.get:
          ress = await request.get(OperationUrl);
          break;
        case HTTPOperationType.post:
          ress = await request.post(OperationUrl, js);
          break;
        case HTTPOperationType.put:
          ress = await request.put(OperationUrl, js);
          break;
        case HTTPOperationType.delete:
          ress = await request.delete(OperationUrl);
          break;
        default:
          break;
      }
    } catch (error) {
      debugger;
    }

    if (ress.data) {
      return { data: ress.data, res: ress };
      //  return ress.data;
    }
  } catch (error) {
    console.log(error);

    // request = client(token);
    //eger token dusmus ise

    return ress.data;
  }
}

export const clientBlob = (token = null) => {
  const defaultOptions = {
    responseType: "blob",
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      "Content-Type": "application/json",
    },
  };
  return {
    get: (FullURL, options = {}) =>
      axios.get(FullURL, {
        ...defaultOptions,
        ...options,
      }),
    post: (FullURL, data, options = {}) =>
      axios.post(FullURL, data, {
        ...defaultOptions,
        ...options,
      }),
    put: (FullURL, data, options = {}) =>
      axios.put(FullURL, data, {
        ...defaultOptions,
        ...options,
      }),
    delete: (FullURL, options = {}) =>
      axios.delete(FullURL, {
        ...defaultOptions,
        ...options,
      }),
  };
};

export async function OAuth2_MakeRequestAndGetResponseForRefreshToken(
  OperationUrl,
  _HTTPOperationType,
  JsonParams = null
) {
  let request;
  let ress;
  try {
    /*
    let res=await getSession();
    var token = (res!=="" && res!==null && res!=="null" && res!==undefined)?
    JSON.parse(getSession).token:"";
   */
    let access_token = localStorage.getItem("access_token");

    request = client(access_token);

    var js = JSON.stringify(JsonParams);
    //console.log(js);
    switch (_HTTPOperationType) {
      case HTTPOperationType.get:
        ress = await request.get(OperationUrl);
        break;
      case HTTPOperationType.post:
        ress = await request.post(OperationUrl, js);
        break;
      case HTTPOperationType.put:
        ress = await request.put(OperationUrl, js);
        break;
      case HTTPOperationType.delete:
        ress = await request.delete(OperationUrl);
        break;
      default:
        break;
    }

    //eger token alma islemi ise..
    if (
      access_token == null &&
      OperationUrl.endsWith(OAuth2ServiceEndPoints.TOKEN)
    ) {
      if (ress.status === 200) {
        return ress.data;
        //todo ok.
      }
    }
    return ress.data;
  } catch (error) {
    throw error.response.data; //new Error(error.response.data);
  }
}

export async function MakeReqestAndGetResponse(
  OperationUrl,
  _HTTPOperationType,
  JsonParams = null
) {
  let request;
  let ress;
  try {
    /*
    let res=await getSession();
    var token = (res!=="" && res!==null && res!=="null" && res!==undefined)?
    JSON.parse(getSession).token:"";
   */

    /*  var token =
      localStorage.getItem("user") &&
      JSON.parse(localStorage.getItem("user")).token;
*/
    var token = localStorage.getItem("access_token");
    request = client(token);

    var js = JSON.stringify(JsonParams);
    //console.log(js);
    switch (_HTTPOperationType) {
      case HTTPOperationType.get:
        ress = await request.get(OperationUrl);
        break;
      case HTTPOperationType.post:
        ress = await request.post(OperationUrl, js);
        break;
      case HTTPOperationType.put:
        ress = await request.put(OperationUrl, js);
        break;
      case HTTPOperationType.delete:
        ress = await request.delete(OperationUrl);
        break;
      default:
        break;
    }

    if (ress.data.isLoginRequired === false) return ress.data;
    else {
      localStorage.removeItem("user");
      window.location.reload(true);
    }
  } catch (error) {
    debugger;
    console.log(error);

    // request = client(token);
    //eger token dusmus ise

    await request
      .post(GetBaseURL() + UserEndPoints.GET_USERDETAIL, {})
      .then((xx) => {
        if (xx.data.isLoginRequired === true) {
          localStorage.removeItem("user");
          window.location.reload(true);
        }
      })
      .catch((xx) => {
        debugger;
        if (xx.response.status === 401) {
          localStorage.clear();
          Emitter.emit("LOGOUT");
        }
      });

    return ress.data;
  }
}

export const HTTPOperationType = {
  get: "get",
  post: "post",
  put: "put",
  delete: "delete",
};

export const client = (token = null, isBlob = false) => {
  let defaultOptions = "";

  if (isBlob) {
    defaultOptions = {
      responseType: "blob",
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "application/json",
      },
    };
  } else {
    defaultOptions = {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "application/json",
      },
      crossdomain: true,
    };
  }

  return {
    get: (FullURL, options = {}) =>
      axios.get(FullURL, {
        ...defaultOptions,
        ...options,
      }),
    post: (FullURL, data, options = {}) =>
      axios.post(FullURL, data, {
        ...defaultOptions,
        ...options,
      }),
    put: (FullURL, data, options = {}) =>
      axios.put(FullURL, data, {
        ...defaultOptions,
        ...options,
      }),
    delete: (FullURL, options = {}) =>
      axios.delete(FullURL, {
        ...defaultOptions,
        ...options,
      }),
  };
};
